import React,  { useEffect, useState }from 'react';
import { useSelector } from 'react-redux';

import { errorNotification, handleApiError, successNotification, getSectionEMET, isObjectEmpty } from 'utils';

import { fetchQuestionAnswersById, updateEmetQuestionById, updateEmetAnswerById, createAnswerEmet, fetchLastQuestionEmet, createQuestionEmet } from 'api/certifications/emet/questions';

import IconButton from 'components/common/IconButton';


function EMETModal({ question_id, action, handleClose }) {
    const token = useSelector(state => state.authentication.user?.token);

    const [formQuestion, setFormQuestion] = useState({ answers: [{ option: '', is_correct: 1 }, { option: '', is_correct: 0 }] }); // Siempre inicializamos con dos respuestas
    const [selectedSection, setSelectedSection] = useState("");

    useEffect(() => {
		if(token !== null && token !== undefined) {
            if(question_id > 0) 
                loadQuestionById(question_id);
            else 
                loadLastQuestionEmet();
        }
        // eslint-disable-next-line
    }, [token, question_id]); 

    const loadQuestionById = async (id) => {
        try {
            const response = await fetchQuestionAnswersById(id, token);
            let { data } = response;
            if(data.status === 200) {
                setFormQuestion(data.message); 
                setSelectedSection(data.message.section_id);
            }
        } catch(error) {
            handleApiError(error);
        }
    }

    const loadLastQuestionEmet = async (id) => {
        try {
            const response = await fetchLastQuestionEmet(token);
            let { data } = response;
            
            if(data.status === 200) {
                setFormQuestion({
                    ...formQuestion,
                    question_number: isObjectEmpty(data.message) ? data.message.number + 1 : 1
                });
            }
            
        } catch(error) {
            handleApiError(error);
        }
    }

    const handleCreateQuestion = async (data) => {
        if (formQuestion.answers.length < 2) {
            errorNotification("Es necesario agregar al menos dos respuestas.");
            return; // Detener el proceso si no hay al menos dos respuestas
        }
        try {
            const response = await createQuestionEmet(data, token);
            if(response.data.status === 201) {
                formQuestion.answers.forEach(answer => {
                    let data_2 = {
                        question_id: response.data.message,
                        option: answer.option,
                        is_correct: answer.is_correct
                    }
                    handleCreateAnswer(data_2);

                });
                successNotification("Pregunta creada con éxito.");
                handleCloseModal();
            }
        } catch(error) { 
            handleApiError(error);
        }
    }

    const handleCreateAnswer  = async (data) => {
        try {
            const response = await createAnswerEmet(data, token);
            console.log(response);
            if(response.data.status === 201) {
                
            }
        } catch(error) { 
            handleApiError(error);
        }
    }

    const handleUpdateQuestion  = async (id, data) => {
        try {
            const response = await updateEmetQuestionById(id, data, token);
            if(response.data.status === 200) {
                successNotification("Pregunta actualizado con éxito.");
                handleCloseModal();
            }
        } catch(error) { 
            handleApiError(error);
        }
    }

    const handleUpdateAnswer  = async (id, data) => {
        try {
            const response = await updateEmetAnswerById(id, data, token);
            if(response.data.status === 200) {
                
            }
        } catch(error) { 
            handleApiError(error);
        }
    }

    const handleActionUser = (e) => {
        e.preventDefault(); 
        if (e.target.form.checkValidity()) {
            if(action === "Nueva") {
                let data = {
                    section_id: selectedSection,
                    number: formQuestion.question_number,
                    instruction: formQuestion.question_instruction,
                    question: formQuestion.question,
                    points: formQuestion.question_points
                }
                handleCreateQuestion(data);
            } else {
                formQuestion.answers.forEach(answer => {
                    if (answer.hasOwnProperty('answer_id')) {
                        let data = {
                            option: answer.option,
                            is_correct: answer.is_correct
                        }
                        handleUpdateAnswer(answer.answer_id, data);
                    } else {
                        let data = {
                            question_id: question_id,
                            option: answer.option,
                            is_correct: answer.is_correct
                        }
                        handleCreateAnswer(data);
                    }
                });
                let data = {
                    section_id: selectedSection,
                    number: formQuestion.question_number,
                    instruction: formQuestion.question_instruction,
                    question: formQuestion.question,
                    points: formQuestion.question_points
                }
                handleUpdateQuestion(question_id, data);
            }   
        } else errorNotification("Faltan campos requeridos.");
	}

    const handleChangeFormQuestion = (event) => {
		const { name, value } = event.target;
		setFormQuestion({
			...formQuestion,
			[name]: value,
		});
	};

    const handleSectionChange = (event) => {
		const selectedId = event.target.value;
		setSelectedSection(selectedId);  
	};

    const handleAnswerChange = (index, field, value) => {
        const updatedAnswers = [...formQuestion.answers];
        updatedAnswers[index][field] = value; // Actualiza la opción o si es correcta
        setFormQuestion(prevState => ({
            ...prevState,
            answers: updatedAnswers
        }));
    };

    const handleAddAnswer = () => {
        const newAnswer = { option: '', is_correct: 0 }; // Nueva respuesta sin `answer_id`
        setFormQuestion(prevState => ({
            ...prevState,
            answers: [...prevState.answers, newAnswer]
        }));
    };

    const handleDeleteAnswer = (index) => {
        const answerToDelete = formQuestion.answers[index];
        if (!answerToDelete.answer_id) {
            const updatedAnswers = formQuestion.answers.filter((_, i) => i !== index);
            setFormQuestion(prevState => ({
                ...prevState,
                answers: updatedAnswers
            }));
        }
    };

    const handleCloseModal = () => {
        document.getElementById('emetModal').classList.remove('show');
		document.querySelector('.modal-backdrop').remove();
        document.getElementById('emetModal').style.display = 'none';

        cleanForm();

        handleClose();
    }

    const cleanForm = () => {
        setFormQuestion({});
        setSelectedSection("");
    };

    return(
        <div id="emetModal" className="modal modal-cover fade" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{action} Pregunta</h5>
                        <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <form id="formEmet" className="was-validated" >
                                <div className="row row-space-12">
                                    <div className="mb-3 row" >
                                        <div className="col-2">
                                            <label className="form-label">#</label>
                                            <input className="form-control" placeholder="#"
                                                id="question_number"
                                                name="question_number"
                                                type='number'
                                                value={formQuestion.question_number || ''}
                                                onChange={handleChangeFormQuestion}
                                                disabled />
                                        </div>
                                        <div className='col-xl-3'>
                                            <label className="form-label">Sección</label>
                                            <select className="form-select" name="section" onChange={handleSectionChange} value={selectedSection} required >
                                                <option value="">Seleccione un opción</option>
                                                <option value="1">Section I</option>
                                                <option value="2">Section II</option>
                                                <option value="3">Section III</option>
                                                <option value="4">Section IV</option>
                                            </select>
                                        </div>
                                        <div className="col-5">
                                            <label className="form-label">Descripción</label>
                                            <input className="form-control" placeholder="Descripción"
                                                id="section_description"
                                                name="section_description"
                                                value={getSectionEMET(selectedSection) || ''}
                                                onChange={handleChangeFormQuestion}
                                                required              
                                                disabled />
                                        </div>
                                        <div className="col-2">
                                            <label className="form-label">Puntos</label>
                                            <input
                                                className="form-control"
                                                style={{ textAlign: 'right' }}
                                                placeholder="Puntos"
                                                id="question_points"
                                                name="question_points"
                                                type="text"
                                                value={formQuestion.question_points || ''}
                                                onChange={handleChangeFormQuestion}
                                                onInput={(e) => {
                                                    e.target.value = e.target.value.replace(/[^0-9]/g, ''); // Solo permite números
                                                }}
                                                pattern="^[1-9]\d*$"
                                                title="Por favor ingresa un número positivo mayor o igual a 1"
                                                required />
                                        </div>
                                    </div>  
                                    <div className="mb-3 row" >
                                        <div className='col-xl-6'>
                                            <label className="form-label">Pregunta</label>
                                            <textarea className="form-control" 
                                                placeholder="Escribe tu pregunta aquí..."
                                                id="question"
                                                name="question"
                                                value={formQuestion.question || ''}
                                                onChange={handleChangeFormQuestion}
                                                required
                                                pattern=".*\S+.*"
                                                rows="3"
                                                cols="50">
                                            </textarea>
                                        </div>
                                        <div className='col-xl-6'>
                                            <label className="form-label">Instrucción</label>
                                            <textarea className="form-control" 
                                                placeholder="Escribe tu instrucción aquí.."
                                                id="question_instruction"
                                                name="question_instruction"
                                                value={formQuestion.question_instruction || ''}
                                                onChange={handleChangeFormQuestion}
                                                required                                                  
                                                pattern=".*\S+.*"
                                                rows="3"
                                                cols="50">
                                            </textarea>
                                        </div> 
                                    </div>
                                    {formQuestion.answers && Array.isArray(formQuestion.answers) && formQuestion.answers.map((answer, index) => (
                                        <div className="mb-3 row" key={index}>
                                            <div className='col-xl-11'>
                                                <label className="form-label">
                                                    Respuesta #{index + 1}
                                                    {index === 0 && (
                                                        <span className="badge bg-success ms-2">Correcta</span>
                                                    )}
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    placeholder="Opción"
                                                    value={answer.option || ''}
                                                    onChange={(e) => handleAnswerChange(index, 'option', e.target.value)}
                                                    required
                                                    rows="2"
                                                    cols="50"
                                                />
                                            </div>

                                            <div className='col-xl-1 d-flex align-items-center'>
                                                {/* El botón de eliminar solo aparece para respuestas nuevas (sin `answer_id`) */}
                                                {!answer.answer_id && (
                                                    <IconButton 
                                                        variant="falcon-danger"
                                                        size="sm"
                                                        icon="trash"
                                                        transform="shrink-3"
                                                        onClick={() => handleDeleteAnswer(index)}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                    {/* Botón para agregar una nueva respuesta */}
                                    <div className="col-xl-12">
                                        <button type="button" className="btn btn-secondary" onClick={handleAddAnswer}>
                                            Agregar Respuesta
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="modal-footer">
                    <button type="button" className="btn btn-outline-default" onClick={handleCloseModal}>Cerrar</button>
                        <button type="button" className="btn btn-outline-theme" onClick={handleActionUser} form="formEmet" >Guardar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EMETModal;